import AxiosClient from "../../../services/axios.services";

class CoursesServices {
  getCourse = (params) =>
    AxiosClient.get(
      "/api/app/descriptor_perfil_cursos_diplomados_seminario_pasantia/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getCourseByID = (id) =>
    AxiosClient.get(
      `/api/app/descriptor_perfil_cursos_diplomados_seminario_pasantia/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveCourse = (data) =>
    AxiosClient.post(
      "/api/app/descriptor_perfil_cursos_diplomados_seminario_pasantia/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editCourse = (id, data) =>
    AxiosClient.put(
      `/api/app/descriptor_perfil_cursos_diplomados_seminario_pasantia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCourse = (id) =>
    AxiosClient.delete(
      `/api/app/descriptor_perfil_cursos_diplomados_seminario_pasantia/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CoursesServices();
